<template>
  <div class="od-card">
    <div class="od-card-header">
      <div class="od-card-header-left">
        <a-icon type="box-plot" class="od-card-header-icon" />
        <p class="od-card-header-title">
          Detail Produk
        </p>
      </div>
    </div>
    <div>
      <div v-for="(item, idx) in order.items" :key="idx" class="od-product-item">
        <img
          v-if="item.image_url"
          :src="item.image_url"
          :alt="item.title"
          class="od-product-img"
        />
        <div v-else class="od-product-img-placeholder">
          <a-icon type="picture" />
        </div>

        <div class="od-product-info">
          <p class="od-product-name">
            {{ item.title }}
          </p>
          <div>
            <span class="od-product-price">{{ toCurrency(item.selling_price) }}</span>
            <br />
            <span class="od-product-qty">{{ item.qty }} {{ item.uom }}</span>
          </div>
          <div v-if="item.original_price && item.original_price > item.selling_price" class="od-flex od-flex-center od-gap-2 od-mt-4">
            <span class="od-product-original">{{ toCurrency(item.original_price) }}</span>
            <span class="od-product-discount-badge">
              <template v-if="item.promotion_type === 'percentage'">
                -{{ item.product_discount_value }}%
              </template>
              <template v-else>
                -{{ toCurrency(item.product_discount_value) }}
              </template>
            </span>
          </div>
        </div>

        <span class="od-product-subtotal">{{ toCurrency(item.selling_price * item.qty) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderProductList',
  props: {
    order: { type: Object, default: null },
    toCurrency: { type: Function, required: true },
  },
}
</script>
